import { ILanguage } from '../../interfaces/ILanguage'

export const sv: ILanguage = {
   '365Robust': '365Robust',
   Loading: 'Laddar...',
   LoadingActivities: 'Hämtar aktiviteter...',
   Of: 'av',

   MobileViewUnderConstruction: 'Mobilversionen av 365Robust är för närvarande under utveckling.',
   PleaseUseComputerToAccessTheApplication: 'Vi ber dig därför vänligen att använda en dator för att få tillgång till tjänsten. Tack för din förståelse!',
   KindRegards365RobustTeam: 'Mvh 365Robust teamet.',

   // Authentication
   WelcomeTo: 'Välkommen till',
   SignIn: 'Logga in',
   SignOut: 'Logga ut',
   Dashboard: 'Dashboard',
   NotAuthorized: 'Ej behörig',
   IdentifyWithBankId: 'Identifiera dig med BankID',
   ShowQRCode: 'Visa QR-kod',
   BankIdInstructions: 'Starta BankID-appen på din mobil eller surfplatta och tryck på "Skanna QR-kod"',
   QRCodeAltText: 'QR-kod, skanna med BankID-appen, håll din telefon i porträttläge 40 cm från skärmen. Klicka för att gå till helskärmsläge',
   ExitFullScreen: 'Stäng fullskärmsläge',
   SecondsLeft: 'sekunder kvar',
   QRTimeout: 'QR-koden har gått ut',
   SignInWithBankId: 'Logga in med BankID',
   SigningIn: 'Loggar in',
   NoAccountRegistered: 'Inget konto hittades för detta personnummer',
   TryAgain: 'Försök igen',
   NoAccessMessage: 'Du har inte behörighet att utföra denna åtgärd.',

   // Bankid user messages
   RFA1: 'Starta BankID-appen.',
   RFA2: 'Du verkar inte ha BankID-appen. Installera den och skaffa ett BankID.',
   RFA3: 'Åtgärden avbröts. Försök igen.',
   RFA4: 'En identifiering eller underskrift pågår redan för ditt personnummer. Försök igen.',
   RFA5: 'Något gick fel. Försök igen.',
   RFA6: 'Åtgärden avbröts.',
   RFA8: 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Försök sedan igen.',
   RFA9: 'Skriv in din säkerhetskod i BankID-appen och välj Identifiera eller Skriv under.',
   RFA13: 'Försöker starta BankID-appen.',
   RFA15a: 'Söker efter BankID. Säkerställ att du har ett giltigt BankID på den här datorn. Om du har ett BankID på kort, sätt in kortet i kortläsaren.',
   RFA15b: 'Söker efter BankID. Säkerställ att du har ett gitligt BankID på den här enheten.',
   RFA16: 'Ditt BankID är för gammalt eller spärrat. Använd ett annat BankID eller skaffa ett nytt hos din bank.',
   RFA17a: 'Du verkar inte ha BankID-appen/programmet. Installera den och skaffa ett BankID hos din bank.',
   RFA17b: 'Misslyckades att läsa av QR-koden. Starta BankID-appen och läs av QR-koden.',
   RFA19: 'Vill du använda BankID på den här datorn eller ett Mobilt BankID?',
   RFA20: 'Vill du använda BankID på den här enheten eller på en annan enhet?',
   RFA21: 'En identifiering eller underskrift pågår.',
   RFA22: 'Något gick fel. Försök igen.',
   RFA23: 'Fotografera och läs av din ID-handling med BankID-appen.',
   UpdateToLatestVersionOfBankId: 'Var vänlig uppdatera din BankID-app till den senaste versionen för att fortsätta.',

   // Organisation
   Organisation: 'Organisation',
   OrganisationalData: 'Organisationsuppgifter',
   OrganisationNumber: 'Organisationsnummer',
   CompanyName: 'Företagsnamn',
   OrganisationSize: 'Organisationsstorlek',
   OrganisationType: 'Organisationsform',
   SNI: 'SNI',
   All: 'Alla',
   OrganisationDetails: 'Organisationsuppgifter',
   InvoiceDetails: 'Fakturauppgifter',
   Invocing: 'Fakturering',
   OtherInvoiceDetails: 'Övriga fakturauppgifter',
   ZipNumberMustBe5Digits: 'Postnummer måste vara 5 siffror (XXX XX)',
   InvalidPhoneNumber: 'Ogiltigt telefonnummer',

   // User
   AccountInformation: 'Användaruppgifter',
   Account: 'Konto',
   FirstName: 'Förnamn',
   LastName: 'Efternamn',
   OrganizationalAffiliation: 'Organisationstillhörighet',
   JobTitle: 'Jobbtitel',
   UserType: 'Användartyp',
   Roles: 'Roller',
   PersonalIdentityNumber: 'Personnummer',
   PersonalIdentityNumberFormat: 'ÅÅÅÅMMDD-XXXX',
   PersonalIdentityNumberMustBe12Digits: 'Personnummer måste vara 12 siffror (ÅÅÅÅMMDD-XXXX)',
   AtleastOneUserMustBeSystemAdministrator: 'Minst en användare måste vara systemadministratör',
   PaymentIsMadeViaMonthlyInvoicing: 'Betalning sker via löpande månadsfakturering',

   // Button
   Next: 'Nästa',
   Add: 'Lägg till',
   Finish: 'Avsluta',
   Cancel: 'Avbryt',
   Continue: 'Fortsätt',
   Save: 'Spara',
   Create: 'Skapa',
   Update: 'Uppdatera',
   Delete: 'Radera',
   ReadMore: 'Läs mer',
   Close: 'Stäng',
   Complete: 'Fastställ',
   Determine: 'Fastställ',
   Back: 'Tillbaka',
   ExportToExcel: 'Exportera till Excel',
   ExportLawlistToExcel: 'Exportera laglista till Excel',
   Criteria: 'Kriterier',
   ResetDecision: 'Återställ beslut',
   ResetDecisionConfirmationMessage: 'Är du säker på att du vill återställa beslutet om åtgärd? Det går inte att ångra sig.',
   ResetAnswer: 'Återställ svar',
   ResetAnswerConfirmationMessage:
      'Är du säker på att du vill återställa svaret? Om frågan har en kopplad åtgärdsplan kommer den att raderas. Det går inte att ångra sig.',
   AnswerReset: 'Svar återställt',
   CouldNotResetAnswer: 'Det gick ej att återställa svaret',
   AddProtectedAsset: 'Lägg till skyddsvärd tillgång',
   AddOrganisationGoal: 'Lägg till organisationsmål',
   NotNow: 'Inte nu',

   // Roles
   ProcessOwner: 'Processägare',
   Owner: 'Ägare',
   RiskOwner: 'Riskägare',
   AnalysisLeader: 'Analysledare',

   // Billing
   BillingData: 'Fakturauppgifter',
   InvoiceReference: 'Fakturareferens',
   InvoiceAddress: 'Fakturaadress',
   PostalCode: 'Postnummer',
   County: 'Postort',
   PhoneNumber: 'Telefonnummer',
   Email: 'E-post',

   // Workplace
   Workplace: 'Arbetsställe',
   Workplaces: 'Arbetsställen',
   TheWorkplace: 'Arbetsstället',
   WorkplaceName: 'Namn på arbetsställe',
   OrganisationForm: 'Organisationsform',
   SNICodes: 'SNI-koder',
   WorkplaceDescription: 'Verksamhetsbeskrivning',
   VisitingAdress: 'Besöksadress',
   CFAR: 'CFAR-nr',
   InvalidCfar: 'Endast siffror är tillåtna',
   CfarLengthMessage: 'CFAR måste vara exakt 8 siffror',
   NumberOfEmployees: 'Antal anställda',
   NewWorkplace: 'Nytt arbetsställe',
   Address: 'Adress',
   TheWorkplaceIsInUseAndCannotBeDeleted: 'Arbetsstället är i bruk och kan ej raderas.',
   OnlySystemAdministratorCanDeleteWorkplaces: 'Endast en systemadministratör kan radera arbetsställen',
   TimeToCreateYourFirstWorkplace: 'Dags att skapa ditt första arbetsställe',

   // ProtectedAssets
   ProtectedAssets: 'Skyddsvärda tillgångar',
   ProtectedAsset: 'Skyddsvärd tillgång',
   TheProtectedAsset: 'Skyddsvärda tillgången',
   Asset: 'Tillgång',
   'ProtectedAsset/OrganisationalGoal': 'Skyddsvärd tillgång/Organisationens mål',
   WorkplaceAffiliation: 'Arbetsplatstillhörighet',
   DescriptionOfAsset: 'Beskrivning av tillgång',
   Description: 'Beskrivning',
   ProtectedAssetValuation: 'Värdering av tillgång',
   AddedAssets: 'Tillagda tillgångar',
   NewDemandAssessment: 'Ny kravbedömning',
   OngoingDemandAssessments: 'Pågående kravbedömningar',
   ConcludedDemandAssessments: 'Avslutade kravbedömningar',
   AccessAffectsFollowingProcesses: 'Tillgång påverkar följande processer',
   MotivationAndStand: 'Motivering och ställningstagande',
   TimeToCreateYourFirstItem: 'Dags att skapa din första {{Item}}',
   NoConcludedItems: 'Det finns inga avslutade {{Item}}',
   OngoingItem: 'Pågående {{Item}}',
   ConcludedItem: 'Avslutade {{Item}}',
   NewItem: 'Ny {{Item}}',
   EditItem: 'Redigera {{Item}}',
   DeleteItem: 'Radera {{Item}}',
   NameOfItem: 'Namn på {{Item}}',
   DescriptionOfItem: 'Beskrivning av {{Item}}',
   ValuationOfItem: 'Värdering av {{Item}}',
   Valuation: 'Värdering',
   ValuationDate: 'Värderingsdatum',
   Name: 'Namn',
   NoProtectedAssetOrGoal: 'Ingen skyddsvärd tillgång eller organisations mål är inlagt',
   NoProtectedAssetOrGoalInfo: 'Det finns ingen skyddsvärd tillgång eller organisations mål inlagda. Dessa kan läggas till under organisationsmenyn.',
   DoYouWantToAddNow: 'Vill du lägga till en nu?',
   TheProtectedAssetIsInUseAndCannotBeDeleted: 'Skyddsvärda tillgången är i bruk och kan ej raderas',
   TheOrganisationalGoalIsInUseAndCannotBeDeleted: 'Det organisatoriska målet är i bruk och kan ej raderas',
   OnlySystemAdministratorCanDeleteProtectedAssets: 'Endast en systemadministratör kan radera skyddsvärda tillgångar',
   OnlySystemAdministratorCanDeleteOrganisationalGoals: 'Endast en systemadministratör kan radera organisatioriska mål',

   // Organisational Goals
   NewOrganisationalGoal: 'Nytt organisationsmål',
   OrganisationalGoals: 'Organisationens mål',
   OrganisationalGoal: 'Organisationsmål',
   TheOrganisationalGoal: 'organisatoriska målet',
   TheGoal: 'Målet',

   // StartUpWizard
   CheckAndVerifyOrganisationData: 'Kontrollera och komplettera organisationsuppgifter',
   CheckAndVerifyUserData: 'Kontrollera och komplettera användaruppgifterna',
   User: 'Användare',
   Users: 'Användare',
   SystemAdministrator: 'Systemadministratör',
   OrganisationAffiliation: 'Organisationstillhörighet',

   // ComplianceOfDemands
   ComplianceOfDemands: 'Kravefterlevnad',
   LeadershipPerspective: 'Ledningsperspektiv',
   Subject: 'Ämne',
   InformationManagement: 'Informationshantering',
   StartOfAssessment: 'Start av bedömning',
   EndOfAssessment: 'Avslut av bedömning',
   Comment: 'Kommentar',
   CommentFromDemandCompliance: 'Kommentar från kravefterlevnad',
   CreateAssessment: 'Skapa bedömning',
   Process: 'Process',
   ProcessAffiliation: 'Processtillhörighet',
   CreatingDemandAssessment: 'Skapar upp kravbedömning...',
   DemandAssessmentCreated: 'Din kravbedömning är nu skapad',
   ThisCanTakeAMoment: 'Detta kan ta en stund. Håll enheten öppen',
   ClickContinueToGoToAssessment: "Klicka på 'Fortsätt' för att öppna din bedömning",
   Information: 'Information',
   DemandAnalysis: 'Kravanalys',
   Responsible: 'Ansvarig',
   ActionPlan: 'Åtgärdsplan',
   DemandAssessment: 'Kravbedömning',
   CompleteDemandAssessment: 'Avsluta kravbedömning',
   DeleteDemandAssessment: 'Radera kravbedömning',
   CompleteDemandAssessmentConfirmationMessage: 'Är du säker på att du vill avsluta kravbedömningen? Det går inte att ångra sig när den har blivit avslutad.',
   DeleteDemandAssessmentConfirmationMessage: 'Är du säker på att du vill radera kravbedömningen? Det går inte att ångra sig när den har blivit raderad.',
   AllAnswered: 'Besvarade',
   NoConcludedDemandAssessments: 'Det finns inga avslutade kravbedömningar',
   TimeToCreateYourFirstDemandAssessment: 'Dags att skapa din första kravbedömning',
   AllProcesses: 'Alla processer',
   ShowHeadings: 'Visa rubriker',
   'No.': 'Nr',
   Question: 'Fråga',
   QuestionAnswered: 'Fråga besvarad',
   CouldNotAnswerQuestion: 'Det gick ej att besvara frågan',
   CompleteDemandAnalysisConfirmationText:
      'Är du säker på att du vill fastställa kravanalysen för {{process}}? Svaret på frågorna kan ej ändras och åtgärdsplaner skapas upp.',
   EditDemandAssessment: 'Redigera kravbedömning',
   Edit: 'Redigera',
   ProposedAction: 'Förslag till åtgärd',
   BackgroundInformationForTheQuestion: 'Bakgrundsfakta till frågan',
   BackgroundInformation: 'Bakgrundsfakta',
   TipFrom365Robust: '365Robust tipsar',
   OriginDemandForTheQuestion: 'Ursprungskrav till frågan',
   OriginDemand: 'Ursprungskrav',
   Source: 'Källa',
   DemandAssessmentCompleted: 'Kravbedömning avslutad',
   CouldNotCompleteDemandAssessment: 'Kunde ej avsluta kravbedömningen',
   CouldNotUpdateDemandAssessment: 'Kunde inte uppdatera kravbedömnignen',
   AssessmentName: 'Namn på bedömning',
   NoAvailableInformation: 'Det finns ingen tillgänglig information för tillfället',
   EstimatedCost: 'Uppskattad kostnad för åtgärd',
   EstimatedCostShort: 'Uppskattad kostnad',
   TotalEstimatedCost: 'Total uppskattad kostnad',
   BudgetedCost: 'Budgeterad kostnad',
   TotalBudgetedCost: 'Totalt budgeterad kostnad',
   ProcessOwnersForDemandAssessment: 'Processägare för kravanalysen',
   ProcessOwnerForDemandAssessmentText:
      'Välj befintlig användare eller skriv in fritt namn. Aktiva användare kommer kunna besvara frågor. Namn utan användare kommer endast administratörer kunna besvara.',
   NotIncluded: 'Ej inkluderat',
   Included: 'Inkluderat',
   ProcessWithProcessowner: 'Process med processägare',
   DeleteDemandAssessmentNoAccessMessage: 'Du har inte behörighet att radera kravbedömningen',
   DemandLevel: 'Kravnivå',

   // Report
   Report: 'Rapport',
   AnsweredQuestionReport: 'Besvarade frågor - Rapport',
   AnsweredQuestions: 'Besvarade frågor',
   TotalNumber: 'Totalt antal',
   NumberOfAnswered: 'Antal besvarade',
   Chart: 'Diagram',
   List: 'Lista',

   // Actionplans
   NoActionPlansCreatedForDemandAssessment: 'Kravanalysen per process måste fastställas innan en åtgärdsplan skapas för processen',
   NoActionPlansCreatedForFinancialYear: 'En åtgärdsplan skapas upp om ett förslag till åtgärd skapats på en kostnad ',
   NoActionPlansRequiredForThisItem: 'Inga åtgärder behöver vidtas i denna {{Item}}.',
   NoActionPlansRequiredForThisFinancialYear: 'Inga åtgärder behöver vidtas i detta räkenskapsår.',
   DemandAssessmentCanBeCompleted: 'Kravbedömningen kan nu avslutas',
   RiskAssessmentCanBeCompleted: 'Riskbedömningen kan nu avslutas',
   ComplianceLevel: 'Efterlevnadsnivå',
   DecisionOnAction: 'Beslut om åtgärd',
   NoActionShallBeTaken: 'Inga åtgärder ska vidtas',
   ResponsibleOfAction: 'Ansvarig för åtgärd',
   Priority: 'Prioritet',
   ID: 'ID',
   AnsweredBy: 'Besvarad av',
   StartAction: 'Påbörja åtgärd',
   CompleteAction: 'Avsluta åtgärd',
   ActionDecidedBy: 'Åtgärd beslutad av',
   NoActionsTaken: 'Inga åtgärder genomfördes',
   ImplementedActions: 'Genomförda åtgärder',
   ComplianceLevelAfterCompletedAction: 'Kravefterlevnad efter utförd åtgärd',
   SpecifyCompliance: 'Ange efterlevnad',
   CalculatedOutcome: 'Beräknat utfall',
   DecisionStatus: 'Beslutsstatus',
   DecidedMulti: 'Beslutade',
   TotalNumberOfActions: 'Totalt antal åtgärder',
   Deadline: 'Klart senast',
   PerProcessAndComplianceLevel: 'Per process & efterlevnadsnivå',
   PerComplianceLevel: 'Per efterlevnadsnivå',
   ActionPlanReport: 'Åtgärdsplan - Rapport',
   NumberOfActions: 'Antal åtgärder',
   AnalysedBy: 'Analyserad av',
   ProposedBy: 'Förslag av',

   // Status
   RequiredField: 'Vänligen, fyll i detta fält',
   SomethingWentWrong: 'Något gick fel',
   NoMatchingQuestonsFound: 'Inga matchande frågor hittades',
   AssessmentMayHaveBeenCreated: 'Skapandet tog längre tid än förväntat. Kravbedömningen kan ha skapats — kontrollera listan.',
   FetchFailed: 'Hämtning misslyckades',
   ModifiedBy: 'Senast ändrad av',
   Modified: 'Senast ändrad',
   CreatedBy: 'Skapad av',
   CreatedDate: 'Skapad',
   ItemSuccessfullyCreated: '{{Item}} skapades korrekt',
   ItemSuccessfullySaved: '{{Item}} sparades korrekt',
   ItemSuccessfullyUpdated: '{{Item}} uppdaterades korrekt',
   ItemSuccessfullyDeleted: '{{Item}} raderades',
   CouldNotFetchItem: '{{Item}} kunde inte hämtas',
   CouldNotCreateItem: '{{Item}} kunde inte skapas',
   CouldNotUpdateItem: '{{Item}} kunde inte uppdateras',
   CouldNotDeleteItem: '{{Item}} kunde inte raderas',
   CouldNotFetchData: 'Data kunde inte hämtas',
   Status: 'Status',
   NoDateSet: 'Inget datum satt',
   NoValueSet: 'Inget värde satt',
   ValidationFailed: 'Validering misslyckades',
   DemandAnalysisCompleted: 'Kravanalysen är fastställd',
   CouldNotCompleteDemandAnalysis: 'Något gick fel när kravanalysen skulle fastställas',
   NotAnswered: 'Ej besvarad',
   Answered: 'Besvarad',
   Determined: 'Fastställd',
   NotDecided: 'Ej beslutad',
   Decided: 'Beslutad',
   NotStarted: 'Ej påbörjad',
   Started: 'Påbörjad',
   Completed: 'Avslutad',
   NotToBeAdressed: 'Åtgärdas ej',
   ErrorMessage: 'Felmeddelande',

   // Error page (fallback när något kastar under rendering)
   ErrorNotFoundTitle: 'Sidan kunde inte hittas',
   ErrorBadRequestMessage: 'Informationen kunde inte behandlas. Kontrollera uppgifterna och försök igen.',
   ErrorSessionExpiredMessage: 'Din session har gått ut. Logga in igen för att fortsätta.',
   ErrorForbiddenMessage: 'Du har inte behörighet att se den här informationen.',
   ErrorNotFoundMessage: 'Vi kunde inte hitta det du letade efter. Sidan kan ha flyttats eller tagits bort.',
   ErrorConflictMessage: 'Informationen har ändrats av någon annan. Ladda om sidan och försök igen.',
   ErrorTimeoutMessage: 'Det tog för lång tid att få svar från tjänsten. Försök igen om en stund.',
   ErrorServerMessage: 'Ett fel uppstod i tjänsten. Felet har loggats — försök igen om en stund.',
   ErrorNetworkMessage: 'Vi kunde inte nå tjänsten. Kontrollera din internetanslutning och försök igen.',
   ErrorUnexpectedMessage: 'Ett oväntat fel inträffade. Du kan försöka igen eller gå tillbaka till startsidan.',
   ErrorContactSupport: 'Om felet återkommer, kontakta supporten och uppge informationen nedan.',
   ErrorOccurredAt: 'Tidpunkt',
   ReferenceId: 'Referens',
   ReloadPage: 'Ladda om sidan',
   GoToStartPage: 'Till startsidan',
   ShowTechnicalDetails: 'Visa teknisk information',
   CopyErrorDetails: 'Kopiera felinformation',
   CopiedToClipboard: 'Kopierat',
   NoDataCreatedYet: 'Ingen data skapad ännu.',
   Ongoing: 'Pågående',
   Concluded: 'Avslutade',
   EndDateMustBeAfterStartDate: 'Slutdatum måste vara efter startdatum.',
   EndDateMustBeAfterOrTheSameAsStartDate: 'Slutdatum måste vara efter eller samma som startdatum.',
   AnAccountMustBeSelected: 'Ett konto måste väljas',
   AtLeastOneWorkplaceMustBeSelected: 'Minst ett arbetsställe måste väljas',
   ItemIsConnectedToItemAndCantBeDeleted: '{{ItemA}} är kopplad till {{Article}} {{ItemB}} och kan ej raderas',
   OnlySystemAdministratorOrOwnerCanDeleteItem: 'Endast en systemadministratör eller ägare kan radera detta {{Item}}',
   OnlySystemAdministratorOrRiskOwnerCanDeleteItem: 'Endast en systemadministratör eller riskägare kan radera detta {{Item}}',
   NoMatchingItemFound: 'Ingen matchande {{Item}} hittades',
   UserNotAllowedToActionItem: 'Användaren har inte behörighet att {{Action}} {{Item}}',
   FeatureRequiresUpgrade: 'Uppgradera abonnemang för att få tillgång till denna funktion',
   ValueSetAutomatically: 'Detta värde sätts automatiskt',
   ValueCannotBeChanged: 'Detta värde kan inte ändras',
   FeatureRequiresConsequenceRiskOrSimplifiedRisk:
      'Denna funktion kräver att tilläggsmodul förenklad riskanalys eller konsekvens- & sannolikhetsanalys är aktiverad',
   ChooseAnAdditionalModuleToEnableThisField: 'Välj en tilläggsmodul för att aktivera detta fält',
   TheAdditionalModuleDoesNotHaveClauses: 'Tilläggsmodulen har inga klausuler',
   OnlyAdditionalModuleTooltip: 'Bedömningen kommer endast att baseras på tilläggsmodulens krav.',

   // Riskmanagement:
   CreateAssesment: 'Skapa bedömning',
   RiskAssesment: 'Riskbedömning',
   RiskAnalysis: 'Riskanalys',
   RiskManagement: 'Riskhantering',
   NewRiskAssesment: 'Ny riskbedömning',
   TypeOfRiskAssesment: 'Typ av riskanalys',
   NameOfAssesment: 'Namn på bedömning',
   'Purpose/Scope': 'Syfte/Omfattning',
   Limitations: 'Avgränsningar',
   StartOfAssesment: 'Start av bedömning',
   EndOfAssesment: 'Avslut av bedömning',
   SimplifiedRiskAnalysis: 'Förenklad riskanalys',
   ConsequenceAndProbabilityAnalysis: 'Konsekvens- & sannolikhetsanalys',
   SimplifiedConsequenceProbabilityAnalysis: 'Förenklad konsekvens- och sannolikhetsanalys',
   SWOTAnalysis: 'SWOT-analys',
   Type: 'Typ',
   NoConcludedRiskAssesments: 'Det finns inga avslutade riskbedömningar',
   TimeToCreateYourFirstRiskAssesment: 'Dags att skapa din första riskbedömning',
   OngoingRiskAssesments: 'Pågående riskbedömningar',
   ConcludedRiskAssesments: 'Avslutade riskbedömningar',
   CreatingRiskAssesment: 'Skapar riskbedömning',
   RiskAssesmentCreated: 'Din riskbedömning är nu skapad',
   RiskIdentifying: 'Riskidentifiering',
   'RiskAnalysis&Evaluation': 'Riskanalys & värdering',
   AnalyseEvaluate: 'Analysera & värdera',
   Identify: 'Identifiera',
   RiskManagementPlan: 'Riskhanteringsplan',
   NewRisk: 'Ny risk',
   EditRisk: 'Redigera risk',
   RiskScenario: 'Riskscenario',
   RiskSource: 'Riskkälla',
   IdentifyRisk: 'Identifiera risk',
   WeaknessesOrCurrentProtection: 'Sårbarheter eller nuvarande skydd ',
   UnderlyingMotivationAndStand: 'Underliggande motivering och ställningstagande',
   Consequence: 'Konsekvens',
   ConsequenceDescription: 'Konsekvensbeskrivning',
   NoRisksIdentifiedYet: 'Inga risker har ännu identifierats',
   Risk: 'Risk',
   TheRisk: 'Risken',
   Title: 'Rubrik',
   CompleteRiskAssessment: 'Avsluta riskbedömning',
   DeleteRiskAssessment: 'Radera riskbedömning',
   CompleteRiskAssessmentConfirmationMessage: 'Är du säker på att du vill avsluta riskbedömningen? Det går inte att ångra sig när den har blivit avslutad.',
   DeleteRiskAssessmentConfirmationMessage: 'Är du säker på att du vill radera riskbedömningen? Det går inte att ångra sig när den har blivit raderad.',
   RiskAssessmentCompleted: 'Riskbedömningen avslutad',
   CouldNotCompleteRiskAssessment: 'Kunde ej avsluta riskbedömningen',
   DetermineRiskAssesmentConfirmationText:
      'Är du säker på att du vill fastställa riskanalysen? Värdering och åtgärder kan ej ändras och åtgärdsplaner skapas upp.',
   DetermineAnalysis: 'Fastställ analys',
   EditRiskAssesment: 'Redigera riskbedömning',
   RiskCriteria: 'Riskkriterier',
   NotAssessed: 'Ej bedömd',
   Unacceptable: 'Oacceptabel risk',
   Questionable: 'Tveksam risk',
   Acceptable: 'Acceptabel risk',
   BigRiskShouldBeAddressed: 'Stor risk, ska åtgärdas',
   UncertaintyAboutRiskShouldBeAddressed: 'Osäkerhet kring risken, bör åtgärdas',
   SmallRiskShouldNotBeAddressed: 'Liten risk, åtgärdas ej',
   RiskLevel: 'Risknivå',
   AnalyseRisk: 'Analysera risk',
   DeleteRiskAnalysisNoAccessMessage: 'Du har inte behörighet att radera riskanalysen',
   VeryHighPriority: 'Mycket hög',
   HighPriority: 'Hög',
   LowPriority: 'Låg ',
   VeryLowPriority: 'Mycket låg',

   // SWOT
   Strengths: 'Styrkor',
   Weaknesses: 'Svagheter',
   Opportunities: 'Möjligheter',
   Threats: 'Hot',
   Strength: 'Styrka',
   Weakness: 'Svaghet',
   Opportunity: 'Möjlighet',
   Threat: 'Hot',
   TheThreat: 'Hotet',
   SWOT: 'SWOT',
   TimeToAddYourFirstSWOT: 'Dags att lägga till din första SWOT',
   Order: 'Ordning',
   ChangeOrder: 'Ändra ordning',
   ActionProposal: 'Åtgärdsförslag',
   CreateProposedAction: 'Skapa förslag till åtgärd',
   of: 'av',
   ValueInOrderOfImportance: 'Värdera i viktighetsgrad',
   NoSWOTMatchingSelectedFilter: 'Det finns inga SWOTs som matchar vald filtrering',
   Graph: 'Grafisk',
   NoTypeIdentified: 'Inga {{type}} är identifierade',

   // Consequence and probability analysis
   ThreatScenario: 'Hotbild',
   RiskEvaluation: 'Riskvärdering',
   NewThreat: 'Nytt hot',
   EditThreat: 'Redigera hot',
   CurrentThreat: 'Aktuellt hot',
   AnalyseDate: 'Analysdatum',
   NoThreatsIdentifiedYet: 'Inga hot har ännu identifierats',
   SpecifyCurrentThreat: 'Ange aktuellt hot',
   VeryHigh: 'Mycket hög risk',
   High: 'Hög risk',
   Moderate: 'Medelhög risk',
   Low: 'Låg risk',
   VeryLow: 'Mycket låg risk',
   Probable: 'Sannolik',
   Likely: 'Trolig',
   Possible: 'Möjlig',
   LessLikely: 'Mindre trolig',
   Unlikely: 'Osannolik',
   Severe: 'Synnerligen allvarlig',
   Serious: 'Allvarlig',
   Significant: 'Kännbar',
   Mild: 'Lindrig',
   Negligible: 'Försumbar',
   ConsequenceLifeAndHealth: 'Konsekvens liv och hälsa',
   ConsequenceEconomy: 'Konsekvens ekonomi',
   ConsequenceEnvironment: 'Konsekvens miljö',
   ConsequenceBrand: 'Konsekvens varumärke',
   Probability: 'Sannolikhet',
   ProbabilityScale: 'Sannolikhetsskala',
   ProbabilityScaleInfo:
      ' Sannolikhetsskalan består av fem skalsteg och är anpassad till MSB (Myndigheten för Samhällsskydd och Beredskap samt Säkerhetspolisens kriterier.',
   ConsequenceLifeAndHealthScale: 'Konsekvensskala - Liv & hälsa',
   ConsequenceLifeAndHealthScaleInfo:
      'Konsekvens för liv och hälsa kan bedömas ur två perspektiv. Antingen som en avbrottshändelse som får konsekvenser för hela verksamheten. Om en eller flera drabbas allvarligt innebär det att verksamheten får svårigheter att uppnå sina mål. Det är grunden för riskbedömningen enligt denna metod. Ska ni bedöma till exempel arbetsmiljöskador bör skalan innehålla andra typer av skador, till exempel förslitning, buller, vibrationer, social oro och så vidare.',
   ConsequenceEconomyScale: 'Konsekvensskala - Ekonomi',
   ConsequenceEconomyScaleInfo:
      'Konsekvens för ekonomi mäts monetärt och utgår från verksamhetens budgeterade omsättning under det aktuella året. Skalan tar inte hänsyn till ekonomiskt starka ägare, onormalt stor kassa, utan utgår från en sund verksamhetsekonomi. ',
   ConsequenceEnvironmentScale: 'Konsekvensskala - Miljö',
   ConsequenceEnvironmentScaleInfo:
      'I de fall miljöpåverkan ska värderas utgår konsekvensskalan från behov av sanering och skadans utbredning i mark, vatten och luft. Dock rekommenderas samma skala som ekonomi, vilket motsvarar motsvarande kostnader för sanering och skadans utbredning. Ta hänsyn till eventuell försäkringsersättning vid bedömningen.',
   ConsequenceBrandScale: 'Konsekvensskala - Varumärke',
   ConsequenceBrandScaleInfo:
      'Konsekvenshanteringen för varumärket utgår från hur påverkan på varumärket sker gällande allvarlighetsgraden, omfattningen av negativ publicitet, kundernas förtroende, finasiell påverkan och återhämtningsmöjligheten.',

   VeryHighDescription: 'Kan inträffa en eller flera gånger per år.',
   HighDescription: 'Kan inträffa inom 1 till 5 år.',
   ModerateDescription: 'Kan inträffa inom 5 till 10 år.',
   LowDescription: 'Kan inträffa inom 10 till 50 år.',
   VeryLowDescription: ' Kan inträffa mer sällan än var 50 år.',

   OfEstimatedRevenue: 'av uppskattad omsättning',

   ProbableLifeHealthDescription: 'Flera döda och/eller svårt skadade',
   LikelyLifeHealthDescription: 'Skada som kräver avancerad läkarvård. Dödsfall kan förekomma',
   PossibleLifeHealthDescription: 'Skada som kräver läkarvård.',
   LessLikelyLifeHealthDescription: 'Skada som kräver enklare vård.',
   UnlikelyLifeHealthDescription: 'Skada som ej kräver vård.',

   ProbableEnvironmentDescription: 'Svår sanering, stor utbredning > 20% av uppskattad omsättning',
   LikelyEnvironmentDescription: 'Svår sanering, liten utbredning > 10% av uppskattad omsättning',
   PossibleEnvironmentDescription: 'Enkel sanering, stor utbredning > 5% av uppskattad omsättning',
   LessLikelyEnvironmentDescription: 'Enkel sanering, liten utbredning > 2% av uppskattad omsättning',
   UnlikelyEnvironmentDescription: 'Ingen sanering, liten utbredning < 2% av uppskattad omsättning',

   ProbableBrandDescription:
      'Varaktigt skadat varumärke, omfattande negativ medial uppmärksamhet, stora ekonomiska förluster, hot mot verksamhetens överlevnad.',
   LikelyBrandDescription: 'Risk att tappa flera viktiga kunder, allvarlig inverkan på varumärket, långsiktiga effekter på verksamhetens kundrelationer.',
   PossibleBrandDescription: 'Upprepad negativ uppmärksamhet i media, risk att tappa enstaka större kund, och fler mindre kunder.',
   LessLikelyBrandDescription: 'Dåligt rykte som uppfattas av flera kunder, uppmärksamhet i riksmedia, risk att tappa enstaka mindre kund.',
   UnlikelyBrandDescription: 'Tillfälligt dåligt rykte, kortvarig uppmärksamhet i lokal media. Ingen större ekonomisk påverkan.',

   // Calendar
   AnnualCalendar: 'Årskalender',
   Activities: 'Aktiviteter',
   Activity: 'Aktivitet',
   TheActivity: 'Aktiviteten',
   AreYouSureYouWantToDeleteActivity: 'Är du säker på att du vill radera aktiviteten?',
   DeleteActivity: 'Radera aktivitet',
   EndDate: 'Slutdatum',
   Color: 'Färg',
   InvalidColor: 'Ogiltig färgkod',
   ChooseColor: 'Klicka för att välja färg',
   Comments: 'Kommentarer',
   AddComment: 'Lägg till kommentar',
   NoComments: 'Inga kommentarer än',
   Week: 'Vecka',
   Quarter: 'Kvartal',
   Month: 'Månad',
   FilterByPeriodType: 'Filtrera på periodtyp',
   FilterByPeriod: 'Filtrera på period',
   NoActivitiesInPeriod: 'Inga aktiviteter under den här perioden',
   OverlappingActivities: 'Överlappande aktiviteter',
   EditActivity: 'Redigera aktivitet',
   PlanActivity: 'Planera aktivitet',
   PlanActivitesMsg: 'Planera aktiviteter för att se dem i årshjulet',
   PlanActivitesPhoneViewMsg: 'Planera aktiviteter för att se dem i listan',
   StartDate: 'Startdatum',
   To: 'till',
   OnlySystemAdministratorCanDeleteActivities: 'Endast en systemadministratör kan radera aktiviteter',
   SendReminder: 'Skicka påminnelse',
   SendReminderConfirmationMessage: 'Ett påminnelsemail skickas till aktivitetens ansvarige. Vill du fortsätta?',
   ReminderSent: 'Påminnelsen har skickats',
   CouldNotSendReminder: 'Det gick inte att skicka påminnelsen',
   OnlySystemAdministratorCanSendReminders: 'Endast en systemadministratör kan skicka påminnelser',
   ActivityHasNoResponsible: 'Aktiviteten saknar ansvarig – det finns ingen att påminna',
   MarkActivityAsCompleted: 'Markera som avslutad',
   MarkActivityAsCompletedConfirmationMessage: 'Är du säker på att du vill markera aktiviteten som avslutad?',
   ReopenActivity: 'Återöppna aktivitet',
   ReopenActivityConfirmationMessage: 'Är du säker på att du vill återöppna aktiviteten?',
   FilterByStatus: 'Filtrera på status',
   NoActivitiesWithStatus: 'Inga aktiviteter med vald status',

   // Settings
   Settings: 'Inställningar',
   SettingsAndRegister: 'Inställningar och register',

   // Risk economy
   RiskEconomy: 'Riskekonomi',
   FinancialYear: 'Räkenskapsår',
   TheFinancialYear: 'Räkenskapsåret',
   NewFinancialYear: 'Nytt räkenskapsår',
   TimeToCreateYourFirstFinancialYear: 'Dags att skapa ditt första räkenskapsår',
   Period: 'Period',
   BudgetedRevenue: 'Budgeterad omsättning',
   IdentifyCosts: 'Identifiera kostnader',
   Budget: 'Budget',
   Result: 'Utfall',
   Cost: 'Kostnad',
   TheCost: 'Kostnaden',
   Evaluation: 'Utvärdering',
   DamageCosts: 'Skadekostnader',
   PreventiveCosts: 'Förebyggande kostnader',
   InsuranceCosts: 'Försäkringskostnader',
   SecurityAdministration: 'Säkerhetsadministration',
   AllCosts: 'Alla kostnader',
   Category: 'Kategori',
   Post: 'Post',
   NumberOfPosts: 'Antal poster',
   SeePosts: 'Se poster',
   AssociatedPosts: 'Tillhörande poster',
   'OriginPost/-s': 'Ursprungspost/-er',
   TotalItem: 'Total {{Item}}',
   Deviation: 'Avvikelse',
   SummaryDeviation: 'Summering avvikelse',
   DeleteItemConfirmationMessage: 'Är du säker på att du vill radera {{Item}}? Det går inte att ångra sig när den har blivit raderad.',
   FilterByCategory: 'Filtrera på kategori',
   FilterOnBudgetOrResult: 'Filtrera på budget eller utfall',
   Date: 'Datum',
   TotalNumberOfPosts: 'Totalt antal poster',
   TotalBudget: 'Total budget',
   TotalResult: 'Totalt utfall',
   TimeToAddYourFirstCost: 'Dags att lägga till din första kostnad',
   Costs: 'Kostnader',
   AddCost: 'Ny kostnad',
   EditCost: 'Redigera kostnad',
   Action: 'Åtgärd',
   CompleteFinancialYear: 'Avsluta räkenskapsåret',
   CompleteFinancialYearConfirmationMessage:
      'Är du säker på att du vill avsluta räkenskapsåret? När du avslutar visas inte detta räkenskapsår i Översikt. Det går inte att ångra sig när den har blivit avslutad.',
   DeleteFinancialYearConfirmationMessage: 'Är du säker på att du vill radera räkenskapsåret? Det går inte att ångra sig när den har blivit raderad.',
   DeleteFinancialYearNoAccessMessage: 'Du har inte behörighet att radera räkenskapsåret',
   FinancialYearCompleted: 'Räkenskapsåret avslutad',
   CouldNotCompleteFinancialYear: 'Kunde ej avsluta räkenskapsåret',
   CreatingFinancialYear: 'Skapar räkenskapsår',
   FinancialYearCreated: 'Ditt räkenskapsår är nu skapat',
   ClickContinueToGoToFinancialYear: 'Klicka på "Fortsätt" för att öppna ditt räkenskapsår',
   AddACostToEvaluate: 'Lägg till en kostnad under "identifiera kostnader" fliken för att kunna utvärdera den',

   // Date picker strings
   January: 'Januari',
   February: 'Februari',
   March: 'Mars',
   April: 'April',
   May: 'Maj',
   June: 'Juni',
   July: 'Juli',
   August: 'Augusti',
   September: 'September',
   October: 'Oktober',
   November: 'November',
   December: 'December',

   Jan: 'Jan',
   Feb: 'Feb',
   Mar: 'Mar',
   Apr: 'Apr',
   MayShort: 'Maj',
   Jun: 'Jun',
   Jul: 'Jul',
   Aug: 'Aug',
   Sep: 'Sep',
   Oct: 'Okt',
   Nov: 'Nov',
   Dec: 'Dec',

   Monday: 'Måndag',
   Tuesday: 'Tisdag',
   Wednesday: 'Onsdag',
   Thursday: 'Torsdag',
   Friday: 'Fredag',
   Saturday: 'Lördag',
   Sunday: 'Söndag',

   MondayShort: 'M',
   TuesdayShort: 'T',
   WednesdayShort: 'O',
   ThursdayShort: 'T',
   FridayShort: 'F',
   SaturdayShort: 'L',
   SundayShort: 'S',

   GoToToday: 'Gå till idag',

   // Data classification
   OpenInformation: 'Öppen information',
   InternalInformation: 'Intern information',
   ConfidentialInformation: 'Sekretessbelagd information',
   LimitedClassifiedInformation: 'Begränsad klassificerad information',

   // Switch organisation
   SwitchOrganisation: 'Byt organisation',
   SelectOrganisation: 'Välj organisation',
   SuccessfullySwitchedOrganisation: 'Organisationen har bytts',
   CouldNotSwitchOrganisation: 'Kunde inte byta organisation',
   AccountNotInOrganisation: 'Kontot tillhör inte organisationen',

   // Subscription
   Subscription: 'Abonnemang',
   ModulesAndUsers: 'Moduler och användare',
   UpgradeSubscription: 'Uppgradera abonnemang',
   ChangeSubscription: 'Ändra abonnemang',
   SystemAdmin: 'Systemadministratör',
   AdditionalModules: 'Tilläggsmoduler',
   AdditionalModule: 'Tilläggsmodul',
   OnlyAdditionalModule: 'Endast tilläggsmodul',
   SubscriptionUpgradeRequiredForPurchaseOfAdditionalModules: 'Uppgradering av abonnemang krävs för köp av tilläggsmoduler',
   AllCurrentModulesForOrganisation: 'Alla organisationens nuvarande moduler',
   PurchaseAdditionalModule: 'Köp tilläggsmodul',
   Free: 'Gratis',
   Start: 'Start',
   Base: 'Bas',
   Extended: 'Utökad',
   Advanced: 'Avancerad',
   SeparateModules: 'Separata moduler',

   // Demandlevel (formerly Subscription) translation for dropdown
   DEMO: 'Demo',
   LINE_MANAGER: 'Linjechef',
   SPECIALIST: 'Specialist',
   CONSULTANT: 'Konsult',
   MANAGEMENT: 'Ledningsgrupp',
   STRATEGIC_DEMAND_ASSESSMENT: 'Strategisk kravbedömning',
   ADD_ON: 'Tillägg',

   // Risk management modules
   SWOT_ANALYSIS: 'SWOT-analys',
   SIMPLIFIED_RISK_ANALYSIS: 'Förenklad riskanalys',
   CONSEQUENCE_AND_PROBABILITY_ANALYSIS: 'Konsekvens- & sannolikhetsanalys',

   // Components modules
   DEMAND_COMPLIANCE: 'Kravefterlevnad',
   RISK_MANAGEMENT: 'Riskhantering',
   RISK_ECONOMY: 'Riskekonomi',
   CALENDAR: 'Kalender',

   // Modules
   Modules: 'Moduler',
   BaseModules: 'Grundmoduler',
   DemandComplianceModules: 'Kravefterlevnadsmoduler',
   RiskManagementModules: 'Riskhanteringsmoduler',

   // Clauses
   Clauses: 'Indelning',

   // Dashboard
   Overview: 'Översikt',
   OverviewData: 'Översiktsdata',
   BiggestRisks: 'Största risker',
   DoADemandAssessment: 'Gör en kravbedömning!',
   DoADemandAssessmentDescription: 'Efterlever ni alla krav som ställs på er verksamhet? Ta reda på det genom en kravbedömning!',
   CreateDemandAssessment: 'Skapa kravbedömning',

   PlanYourCalendar: 'Planera er årskalender',
   PlanYourCalendarDescription: 'När ska nästa kravbedömning göras och när är det dags för en riskbedömning? Börja er planering nu!',
   CreateActivity: 'Skapa aktivitet',

   DoARiskAssessment: 'Gör en riskbedömning!',
   DoARiskAssessmentDescription: 'Identifiera era största risker genom en riskbedömning.',
   CreateRiskAssessment: 'Skapa riskbedömning',

   CreateNewFinancialYear: 'Skapa nytt räkenskapsår',
   CreateNewFinancialYearDescription:
      'Riskekonomi modulen saknar ett räkenskapsår och identifierade kostnader för att få ut ett diagram här. Kom igång med riskekonomin direkt!',
   CreateFinancialYear: 'Skapa räkenskapsår',

   // Contact sales representative
   ContactSalesRepresentativeToChangeOrgDetails: 'Kontakta din säljare för att ändra dina organisationsuppgifter',
   ContactSalesRepresentativeToOrderUsersAndModules: 'Kontakta din säljare för att beställa användare och moduler',

   // Process owner
   NewProcessOwner: 'Ny processägare',
   TheProcessOwner: 'Processägaren',
   ProcessOwnerName: 'Processägarens namn',
   Processes: 'Processer',
   ProcessOwnerInfo: 'Namnge vilka personer inom organisationen som är processägare, vilket påverkar kravbedömningar och riskbedömningar',
   OnlySystemAdministratorCanDeleteProcessOwners: 'Endast en systemadministratör kan radera processägare',
   TheProcessOwnerIsInUseAndCannotBeDeleted: 'Processägaren är i bruk och kan ej raderas',

   // Demand sub type
   EUDirective: 'EU-direktiv',
   Article: 'Artikel',
   Law: 'Lag',
   Ordinance: 'Förordning',
   Paragraph: 'Paragraf',

   // Demand area
   Economy: 'Ekonomi',
   WorkEnviroment: 'Arbetsmiljö',
   Market: 'Marknad',
   Sustainability: 'Hållbarhet',
   Quality: 'Kvalitet',
   Staff: 'Personal',
   Security: 'Säkerhet',
   Management: 'Ledning',
   ITLaw: 'IT-rätt',
   Production: 'Produktion',

   // Export
   Lawlist: 'Laglista',
   LawRequirements: 'Lagkrav',
   PrintDate: 'Utskriftsdatum',
   Source365Robust: 'Källa: 365Robust',

   // Terms and conditions
   TermsAndConditions: 'Avtalsvillkor',
   DownloadTermsAndConditions: 'Hämta avtalsvillkor',
   SuccessfullyDownloadedTermsAndConditions: 'Avtalsvillkor har laddats ner',
   CouldNotDownloadTermsAndConditions: 'Kunde inte ladda ner avtalsvillkor',

   // Other
   A: 'En',
   An: 'Ett',
   The: 'Den',
}
